import { TextAlignment, TextSettings } from '../../canvas/entities/TextConventions';
import { CreateUnstyledTextFieldEditor } from '../../canvas/workspace/adapters/UnstyledTextFieldEditor';
import { SmartButton } from './SmartButton';

export const SmartButtonLabelTextSettings = TextSettings.from({
    ...TextSettings.default,
    fontFamily: 'Rubik',
    fontWeight: 500,
    fontSize: 0,
    lineHeight: 1.2,
    textAlignH: TextAlignment.middle,
    textAlignV: TextAlignment.middle,
});

const SmartButtonLabelFieldEditor = CreateUnstyledTextFieldEditor('label', () => SmartButtonLabelTextSettings);

export const SmartButtonLabelField = (owner: SmartButton) => ({
    ui: SmartButtonLabelFieldEditor,
    name: 'title',
    bounds: owner.layout.label,
    owner,
});
